var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconsOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 13.5,
    viewBox: "0 0 13.5 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.942,3H6.635A1.559,1.559,0,0,0,5.077,4.558v.519H4.558A1.559,1.559,0,0,0,3,6.635v8.308A1.559,1.559,0,0,0,4.558,16.5h8.308a1.559,1.559,0,0,0,1.558-1.558v-.519h.519A1.559,1.559,0,0,0,16.5,12.865V4.558A1.559,1.559,0,0,0,14.942,3Zm-2.6,11.163a.26.26,0,0,1-.26.26H5.337a.26.26,0,0,1-.26-.26v-.519a.26.26,0,0,1,.26-.26h6.75a.26.26,0,0,1,.26.26Zm0-2.077a.26.26,0,0,1-.26.26H5.337a.26.26,0,0,1-.26-.26v-.519a.26.26,0,0,1,.26-.26h6.75a.26.26,0,0,1,.26.26Zm0-2.077a.26.26,0,0,1-.26.26H5.337a.26.26,0,0,1-.26-.26V9.49a.26.26,0,0,1,.26-.26h6.75a.26.26,0,0,1,.26.26Zm0-2.077a.26.26,0,0,1-.26.26H5.337a.26.26,0,0,1-.26-.26V7.413a.26.26,0,0,1,.26-.26h6.75a.26.26,0,0,1,.26.26Zm3.115,4.933a.52.52,0,0,1-.519.519h-.519V6.635a1.559,1.559,0,0,0-1.558-1.558H6.115V4.558a.52.52,0,0,1,.519-.519h8.308a.52.52,0,0,1,.519.519Z",
    transform: "translate(-3 -3)",
    fill: "#888075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconsOrders);
export default __webpack_public_path__ + "static/media/navIcons_Orders.dcced636.svg";
export { ForwardRef as ReactComponent };